export default __webpack_public_path__ + "static/6-a58f00a7a3fbf346ff1b0ceb0d6ddec6.png";